import React, { useEffect, useState } from 'react'
import axios from "axios";
import { baseUrl } from '../../baseUrl';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const CreateStudent = () => {
    const navigate=useNavigate()
    const [message, setMessage] = useState(false)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [contact,setContact]=useState('')
    const [className,setClassName]=useState('')
    const [dob, setDOB] = useState('')
    const [gender, setGender] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [motherName, setMotherName] = useState('')
    const [category, setCategory] = useState('')
    const [reference, setReference] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const resetData= () =>{
        setName('')
        setClassName('')
        setEmail('')
        setContact('')
        setDOB('')
        setGender('')
        setFatherName('')
        setMotherName('')
        setCategory('')
        setReference('')
        setPassword('')
        setConfirmPassword('')
    }
    const data={name,email,contact,className,dob,gender,fatherName,motherName,category,reference,password}
    const [loading,setLoading] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
    }, [message]);

    const handleClass = (e) => {
        setClassName(e.target.value)
    }

    const handleSubmit = async () => {
        if (password !== confirmPassword) {
            toast.error('Please enter Confirm password same as Password')
        }
        else if (name === "" || email === "" || contact===""|| dob === '' || gender === '' || fatherName === '' || motherName === '' ||
            category === '' || password === '' || confirmPassword === ''
        ) {
            toast.error('Make sure you enter all required details')
        }
        else {
            setLoading(true)
            try {
                const checkResponse = await axios.post(`${baseUrl}/student/check-if-exists`, {
                    email,
                });

                // If the email or student ID exists, show an error message
                if (checkResponse.status === 400) {
                    setMessage(checkResponse.data.message); // Show error message
                    return;  // Stop the registration process
                }
                const res= await axios.post(`${baseUrl}/student/web-register`,data)
                resetData()
                navigate('/login')
                toast.success(res.data.message)
                toast.success('You can Log in now')
                const selectedMaterials=[]
                // const selectedMaterials = materialsSelected.map(material => material._id);

                // Proceed with registration and payment initiation
                // const paymentPayload = {
                //     merchantName: "test",
                //     amount: course.price + (selectedMaterials.length > 0 ? selectedMaterials.reduce((acc, m) => acc + m.price, 0) : 0),
                //     merchantMobileNumber: 1234567890,
                //     name, email,contact, className,selectedMaterials, dob, gender, fatherName, motherName, category, reference, password,
                // };

                // Create order and redirect to payment gateway
                // const response = await axios.post(`${baseUrl}/payment/create-order`, paymentPayload);
                // window.location.href = response.data.url;
            } catch (error) {
                console.error("Error checking student data:", error);
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
                if (error.response.data.error) {
                    toast.error(error.response.data.error)
                }
            }finally{
                setLoading(false)
            }
        }
    }

    return (
        <div>
            <div
                className="container"
                style={{ backgroundColor: "#F3F8FB", padding: "40px" }}
            >
                <div className="bg-white p-4">
                    <h4>Student Registration</h4>
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <div className="col-lg-6 col-sm-12">
                                <label htmlFor="name" className="form-label">
                                    Student Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter Name"
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                />
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <label htmlFor="email" className="form-label">
                                    Email
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    placeholder="Enter Email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                        <div className="col-lg-6 col-sm-12">
                                <label htmlFor="contact" className="form-label">
                                    Contact Number
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="contact"
                                    placeholder="Enter contact number"
                                    onChange={(e) => setContact(e.target.value)}
                                    value={contact}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="class" className="form-label">
                                    Class
                                </label>
                                <select value={className} onChange={handleClass} className="form-select" id="class" aria-label="Default select example">
                                    <option hidden>Select Class</option>
                                    <option>Class XI</option>
                                    <option>Class XII</option>
                                    <option>Class XII Passed</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="dob" className="form-label">
                                    Date of Birth
                                </label>
                                <input value={dob} id='dob' type='date' className="form-control" onChange={(e) => setDOB(e.target.value)} />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="gender" className="form-label">
                                    Gender
                                </label>
                                <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-select" id="gender" aria-label="Default select example">
                                    <option hidden>Select Gender</option>
                                    <option value='male'>
                                        Male
                                    </option>
                                    <option value='female'>
                                        Female
                                    </option>
                                    <option value='other'>
                                        Other
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="fatherName" className="form-label">
                                    Father Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="fatherName"
                                    placeholder="Enter Father Name"
                                    onChange={(e) => setFatherName(e.target.value)}
                                    value={fatherName}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="motherName" className="form-label">
                                    Mother Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="motherName"
                                    placeholder="Enter Mother name"
                                    onChange={(e) => setMotherName(e.target.value)}
                                    value={motherName}
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="category" className="form-label">
                                    Category
                                </label>
                                <select value={category} onChange={(e) => setCategory(e.target.value)} className="form-select" id="category" aria-label="Default select example">
                                    <option hidden>Select category</option>
                                    <option>
                                        General
                                    </option>
                                    <option>
                                        OBC
                                    </option>
                                    <option>
                                        SC
                                    </option>
                                    <option>
                                        ST
                                    </option>
                                </select>
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="reference" className="form-label">
                                    Reference
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="reference"
                                    placeholder="Enter reference (optional)"
                                    onChange={(e) => setReference(e.target.value)}
                                    value={reference}
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="password" className="form-label">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    placeholder="Enter password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="confirmPassword" className="form-label">
                                    Confirm Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirmPassword"
                                    placeholder="Re-enter password"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    value={confirmPassword}
                                />
                            </div>
                        </div>
                    </form>
                    {message && (
                        <div
                            className="alert alert-warning alert-dismissible fade show mt-3"
                            role="alert"
                        >
                            {message}
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                onClick={() => setMessage(false)}
                            ></button>
                        </div>
                    )}
                    <button disabled={loading} onClick={handleSubmit} className="btn btn-primary mt-4">
                        {loading?'Loading...':'Register'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CreateStudent
